import { useState } from "react";
import { Loader2 } from "lucide-react";
import { FloatingSearch } from "@/components/create/explore/FloatingSearch";
import { CategoryChips, PresetGrid } from "@/components/create/explore/PresetGrid";
import { StudioHeader } from "@/components/create/explore/StudioHeader";
import { useOpenPreset, usePresets } from "@/lib/studio";
import { cn } from "@/lib/utils";

const KINDS = [{ key: "all", label: "All" }, { key: "image", label: "Image" }, { key: "video", label: "Video" }, { key: "mine", label: "Mine" }];

export default function PresetsPage() {
  const q = usePresets();
  const onOpen = useOpenPreset();
  const [kind, setKind] = useState("all");
  const [category, setCategory] = useState("All");
  const items = (q.data?.items || []).filter((p) => (kind === "mine" ? p.mine : p.status === "published" && (kind === "all" || p.kind === kind)))
    .filter((p) => category === "All" || p.category === category);
  return (
    <div className="h-full overflow-y-auto" data-testid="presets-page">
      <StudioHeader title="Presets" back />
      <div className="mx-auto w-full max-w-6xl space-y-4 px-4 pb-32 pt-5 sm:px-6 sm:pt-8 lg:pb-16">
        <div className="flex gap-1 rounded-full border border-white/[0.08] bg-ink-900 p-1 sm:w-fit" role="tablist" aria-label="Preset type" data-testid="presets-kind-tabs">
          {KINDS.map((k) => (
            <button key={k.key} type="button" role="tab" aria-selected={kind === k.key} onClick={() => setKind(k.key)} data-testid={`presets-kind-${k.key}`}
              className={cn("h-9 flex-1 rounded-full px-4 text-sm transition-colors sm:flex-none", kind === k.key ? "bg-white text-ink-950" : "text-zinc-400 hover:text-zinc-100")}>
              {k.label}
            </button>
          ))}
        </div>
        <CategoryChips categories={q.data?.categories || []} value={category} onChange={setCategory} />
        {q.isLoading && <div className="flex h-40 items-center justify-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin" /></div>}
        {!q.isLoading && items.length === 0 && (
          <p className="py-14 text-center text-sm text-zinc-500" data-testid="presets-empty">
            {kind === "mine" ? "You haven't shared any presets yet. Share one from Assets." : "No presets here yet."}
          </p>
        )}
        <PresetGrid presets={items} onOpen={onOpen} />
      </div>
      <FloatingSearch />
    </div>
  );
}
